import { sendPurchaseEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LicensePurchaseEventAdapter extends EventAdapter {
  protected intercomEventKey = 'purchase';
  protected amplitudeEventFunction = sendPurchaseEvent;

  constructor(
    legacyLicenseModel: any,
    referrer: string,
    paywallFeature: string = null
  ) {
    super();
    try {
      this.eventData = {
        id: legacyLicenseModel.id,
        license_count: legacyLicenseModel.seats,
        years: legacyLicenseModel.years,
        coupon_code: legacyLicenseModel.couponName,
        price: legacyLicenseModel.pricePerSeat,
        referrer: referrer,
        referrer_paywall_feature: paywallFeature,
        applied_seat_to_self: legacyLicenseModel.applyNow,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
